import { CallToAction } from 'components/CallToAction'
import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { prepareData } from 'utils/googleData'

export function HomeCTA3(props) {
  const {
    enable,
    homeCTATitle,
    ctas,
    direction,
    gatsbyImage,
  } = prepareData({ props })

  if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }

  return (
    <section dir={direction} className="relative bg-gradient-to-br from-[#0B1C39] to-[#1B3154] overflow-hidden">
      {/* Background gradient effect */}
      <div className="absolute inset-0 bg-[url('/bg-pattern.png')] opacity-10"></div>
      
      <div className="max-w-7xl mx-auto px-4 py-12 lg:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          {/* Left side - Robot Image */}
          <div className="flex justify-start">
            {gatsbyImage && (
              <GatsbyImage
                image={gatsbyImage}
                alt="iDataworkers Robot"
                className="w-[280px] lg:w-[380px] h-auto -ml-4 lg:-ml-8"
              />
            )}
          </div>

          {/* Right side - Content */}
          <div className="text-left lg:max-w-[540px]">
            <h2 className="text-3xl lg:text-5xl font-bold text-white mb-4">
              {homeCTATitle?.title}
            </h2>
            <p className="text-base lg:text-lg text-white/80 mb-6 dark:text-gray-300">
              {homeCTATitle?.subtitle}
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-3">
              {ctas?.map(({ text, url, style = '' }, index) => (
                <CallToAction
                  key={index}
                  type={index === 0 ? 'secondary' : 'primary'}
                  size="lg"

                  to={url}
                >
                  {text}
                </CallToAction>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom gradient overlay */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-[#0B1C39] to-transparent"></div>
    </section>
  )
}

export default HomeCTA3
